import { BehaviorSubject, Observable } from 'rxjs'
import { CommonRequestFields, Http, ResponseError } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { NotifyPopupService } from '@/views/dashboard/_notify-popup/notify-popup.service'
import { COOKIE_CONFIG } from '@/utils/tool'
import Cookies from 'js-cookie'
import { LoginUserInfo } from '@/services/login.service'
import { router } from '@/router'

export interface UserInfo extends Partial<LoginUserInfo> {
  /** uid */
  uid?: string
  /** token */
  token?: string
}

let lastUserInfo: UserInfo

try {
  lastUserInfo = JSON.parse(Cookies.get('userInfo') || '{}')
} catch (e) {
  lastUserInfo = {}
}

@Injectable()
export class User {
  userInfo: Observable<UserInfo>;
  private _userInfo: UserInfo = lastUserInfo;

  private changeEvent = new BehaviorSubject<UserInfo>(this._userInfo)

  constructor (private http: Http, private notifyPopup: NotifyPopupService) {
    this.userInfo = this.changeEvent.asObservable()
    this.http.addCommonRequestFields({
      uid: lastUserInfo.uid,
      token: lastUserInfo.token
    })
  }

  getUserInfo () {
    return this._userInfo
  }

  /** 后端清除登录态 */
  cleanUserBe (common: CommonRequestFields) {
    if (this.hasUser()) {
      return this.http.post('/user/login_out', { common })
        .catch((err: ResponseError) => {
          // 取消这个接口的错误码提示逻辑
          const uselessVariable = err.responseBody.ret
        })
    }
    return Promise.resolve()
  }

  /** 前端清除登录态 */
  cleanUserFe () {
    this._userInfo = null
    Cookies.remove('userInfo', COOKIE_CONFIG)
    this.http.cleanCommonRequestFields()
    this.notifyPopup.initAll()
  }

  /**
   * 1、不需要等后端清除异步finally再清除前端，因为当退出登录时进行路由切换，路由拦截器判断到登录态还存在，会有各种时机问题
   * 2、采用同步清除，先后端清除再前端清除，不然http的common参数被清除就无法给后端清除
   * 3、http全局common参数清除是同步的，而post要等待异步签名计算，所以cleanUserBe要单独入参common副本避免post时拿不到
   */
  cleanUser () {
    const promise = this.cleanUserBe(this.http.getCommonRequestFields())
    this.cleanUserFe()
    return promise
  }

  hasUser () {
    return !!this._userInfo?.uid
  }

  updateUserinfo (userinfo: UserInfo) {
    this._userInfo = userinfo
    this.http.addCommonRequestFields({
      uid: userinfo.uid,
      token: userinfo.token
    })
    Cookies.set('userInfo', JSON.stringify(userinfo), COOKIE_CONFIG)
    this.changeEvent.next(userinfo)
  }

  /** 从接口更新用户信息 */
  updateRemoteUserInfo () {
    return this.http.post<{ user_info: LoginUserInfo }>('/user/get_info', {}).then((res) => {
      const info = res.user_info
      this.updateUserinfo({
        ...this._userInfo,
        ...info,
      })
    })
  }
}
